import React from "react";

import AddEditExpenseRow from "./AddEditExpenseRow/AddEditExpenseRow";
import { CustomDate } from "../../../../models/custom-date/custom-date";
import { RevenueExpenseRef } from "../../../../models/revenue-expense/revenue-expense-ref";
import { TransactionDTO } from "../../../../models/transactions";

import ConfirmationRemoveItemDialog from "../ConfirmationRemoveItemDialog/ConfirmationRemoveItemDialog";
import { Amounts, HeaderRow, MainBlock, StyledTableCell, TableBodyRow } from "../styles";

interface Props {
  transaction: TransactionDTO;
  readOnly?: boolean;
  handleChange?: (field: keyof TransactionDTO, value: TransactionDTO[keyof TransactionDTO]) => void;
}

const Expenses = ({
  transaction: { expenses, legalEntity, currency, transactionDate },
  readOnly = false,
  handleChange,
}: Props) => {
  const handleChangeExpense = (value: RevenueExpenseRef, idx: number): void => {
    idx < 0
      ? handleChange && handleChange("expenses", [...expenses, value])
      : handleChange && handleChange("expenses", [...expenses.slice(0, idx), value, ...expenses.slice(idx + 1)]);
  };

  const handleRemoveExpense = (idx: number): void =>
    handleChange && handleChange("expenses", [...expenses.slice(0, idx), ...expenses.slice(idx + 1)]);

  return (
    <>
      <MainBlock>
        <HeaderRow container>
          <StyledTableCell>Expense type</StyledTableCell>
          <StyledTableCell>Project</StyledTableCell>
          <StyledTableCell>Employee</StyledTableCell>

          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Amount
          </StyledTableCell>
          <StyledTableCell flex={1}>Exchange rate</StyledTableCell>
          <StyledTableCell
            flex={1}
            align={"right"}
          >
            Booked amount
          </StyledTableCell>
          {!readOnly && (
            <StyledTableCell width={100}>
              <AddEditExpenseRow
                handleChangeExpense={(value) => handleChangeExpense(value, -1)}
                legalEntity={legalEntity}
                currency={currency}
                date={CustomDate.ToDate(transactionDate) as Date}
              />
            </StyledTableCell>
          )}
        </HeaderRow>

        {expenses?.map((expense, idx) => {
          return (
            <TableBodyRow
              container
              key={expense.id}
            >
              <StyledTableCell>{expense?.revenueExpenseType?.name ?? ""}</StyledTableCell>
              <StyledTableCell>{expense?.project?.name ?? ""}</StyledTableCell>
              <StyledTableCell>{expense?.employee?.name ?? ""}</StyledTableCell>

              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+expense?.amount).toLocaleCustom()} ${expense?.currency?.code ?? ""}`}
              >
                <Amounts>{`${(+expense?.amount).toLocaleCustom()} ${expense?.currency?.code ?? ""}`}</Amounts>
              </StyledTableCell>
              <StyledTableCell flex={1}>{expense?.exchangeRate}</StyledTableCell>
              <StyledTableCell
                flex={1}
                align={"right"}
                title={`${(+expense?.bookedAmount).toLocaleCustom()} ${expense?.bookedCurrency?.code ?? ""}`}
              >
                <Amounts>{`${(+expense?.bookedAmount).toLocaleCustom()} ${
                  expense?.bookedCurrency?.code ?? ""
                }`}</Amounts>
              </StyledTableCell>
              {!readOnly && (
                <StyledTableCell width={100}>
                  <AddEditExpenseRow
                    handleChangeExpense={(value) => handleChangeExpense(value, idx)}
                    legalEntity={legalEntity}
                    item={expense}
                    date={CustomDate.ToDate(transactionDate) as Date}
                  />
                  <ConfirmationRemoveItemDialog
                    index={idx}
                    handleRemove={handleRemoveExpense}
                  />
                </StyledTableCell>
              )}
            </TableBodyRow>
          );
        })}
      </MainBlock>
    </>
  );
};

export default Expenses;
